import { render, staticRenderFns } from "./Balances.vue?vue&type=template&id=68c967d0&"
import script from "./Balances.vue?vue&type=script&lang=ts&"
export * from "./Balances.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports